// Import the functions you need from the SDKs you need
import firebase from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCd6xqYYtkO0RCgMLShfn6xsNr30f4UjKk",
  authDomain: "seregela-d6702.firebaseapp.com",
  projectId: "seregela-d6702",
  storageBucket: "seregela-d6702.appspot.com",
  messagingSenderId: "952831985540",
  appId: "1:952831985540:web:60591f18933a560773ffd1",
  measurementId: "G-15YH76WRDL"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
